import api from './api';
import Logger from '../lib/Logger';
import Events from '../lib/EventEmitter';
import Auth from '../lib/Auth';
import Config from '../Config';

export const ADD_ENTITIES = 'ADD_ENTITIES';
export const REMOVE_ENTITY = 'REMOVE_ENTITY';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const SESSION_CREATE_REQUEST = 'SESSION_CREATE_REQUEST';
export const SESSION_CREATE_SUCCESS = 'SESSION_CREATE_SUCCESS';
export const SESSION_CREATE_FAILURE = 'SESSION_CREATE_FAILURE';
export const SESSION_REQUIRES_2FA = 'SESSION_REQUIRES_2FA';
export const SESSION_FORM_DESTROY = 'SESSION_FORM_DESTROY';
export const SESSION_DESTROY = 'SESSION_DESTROY';
export const SESSION_HYDRATE = 'SESSION_HYDRATE';
export const SESSION_PASSWORD_EXIPRED = 'SESSION_PASSWORD_EXIPRED';
export const REMOVE_ENTITYS = 'REMOVE_ENTITYS';

export const addEntities = (entities) => {
  Logger.log('debug', `[actions] addEntities(%j)`, entities);
  return {
    type: ADD_ENTITIES,
    payload: entities
  }
};

export const removeEntitys = (payload) => {
  Logger.log('debug', `[state.actions] removeEntity(###)`, payload);
  return {
    type: REMOVE_ENTITYS,
    payload: payload
  }
};

export const removeEntity = (payload) => {
  Logger.log('debug', `[actions] removeEntity(%j)`, payload);
  return {
    type: REMOVE_ENTITY,
    payload: payload
  }
};

export const sendMessage = (level, title, body, expires) => {
  Logger.log('debug', `[actions] sendMessage("${level}", "${title}", "${body}", ${expires})`);
  if (typeof expires === 'undefined') {
    expires = Config.get('DEFAULT_MESSAGE_TIMEOUT');
  }
  return {
    type: SEND_MESSAGE,
    level: level,
    title: title,
    body: body,
    expires: expires
  }
};

export const removeMessage = (key) => {
  Logger.log('debug', `[actions] removeMessage("${key}")`);
  return {
    type: REMOVE_MESSAGE,
    key: key
  }
};

export function sessionCreateRequest(data) {
  Logger.log('debug', `[actions] sessionCreateRequest()`);
  return {
    type: SESSION_CREATE_REQUEST,
    username: data.username,
    password: data.password,
  }
}

export function sessionCreateSuccess(data) {
  Logger.log('debug', `[actions] sessionCreateSuccess(%j)`, data);
  const tokenClaims = Auth.parseJwt(data.authToken);
  Auth.saveSession(data.authToken, tokenClaims.iat, tokenClaims.exp, tokenClaims.id, tokenClaims.username);
  return {
    type: SESSION_CREATE_SUCCESS,
    authToken: data.authToken,
    update_password: data.update_password,
    authIssuedAt: tokenClaims.iat,
    authExpires: tokenClaims.exp,
    userId: tokenClaims.id,
    username: tokenClaims.username,
    receivedAt: Date.now()
  }
}

export function sessionCreateFailure(error) {
  Logger.log('debug', `[actions] sessionCreateFailure(%j)`, error);
  return {
    type: SESSION_CREATE_FAILURE,
    error: error
  }
}

export function sessionRequires2FA(data) {
  Logger.log('debug', `[actions] sessionRequires2FA(%j)`, data);
  const tokenClaims = Auth.parseJwt(data.otpToken);
  // Auth.saveSession(data.authToken, tokenClaims.iat, tokenClaims.exp, tokenClaims.id, tokenClaims.username);
  return {
    type: SESSION_REQUIRES_2FA,
    otpToken: data.otpToken,
    authIssuedAt: tokenClaims.iat,
    authExpires: tokenClaims.exp,
    userId: tokenClaims.id,
    username: tokenClaims.username,
    challenge: data.challenge,
    secret: data.secret,
    provisioning_uri: data.provisioning_uri,
    receivedAt: Date.now()
  }
}

export function sessionFormDestroy(formState=null) {
  Logger.log('debug', `[state.actions] sessionFormDestroy(###)`, formState);
  return {
    type: SESSION_FORM_DESTROY,
    form: formState
  }
}

export function sessionHydrate(data) {
  Logger.log('debug', `[state.actions] sessionHydrate()`);
  Events.dispatch('SESSION_HYDRATE');
  return {
    type: SESSION_HYDRATE,
    authToken: data.authToken,
    authIssuedAt: data.authIssuedAt,
    authExpires: data.authExpires,
    userId: data.userId,
    username: data.username
  }
}

export function sessionDestroy() {
  Logger.log('debug', `[actions] sessionDestroy()`);
  Auth.deleteSession();
  return {
    type: SESSION_DESTROY
  }
}

export function sessionPasswordExpired() {
  Logger.log('debug', `[actions] sessionPasswordExpired()`);
  return {
    type: SESSION_PASSWORD_EXIPRED
  }
}


// API THUNK ACTION CREATORS

export function createSession(data, cb=function(){}) {
  Logger.log('debug', `[actions] createSession(###, ###)`);

  return async function(dispatch) {
    
    dispatch(sessionCreateRequest(data));

    // call API
    const response = await api.getToken(data.username, data.password, data.token, data.otp);
    let success = false;
    let requires2FA = false;

    // get token success
    if (200 === response.get('status')) {

      Logger.log('info', `GET API token success. User: ${response.getIn(['data', 'user_id'])}`);
      success = true;

      const sessionSuccessData = {
        authToken: response.getIn(['data', 'token']),
        update_password: response.getIn(['data', 'update_password']),
      };

      dispatch(sessionCreateSuccess(sessionSuccessData));
      
    // get token failure
    } else {

      // 2FA challenge
      if (['TOTP', 'TOTP-Enroll'].includes(response.getIn(['data', 'challenge']))) {
        Logger.log('info', `GET API token failure - requires two factor authentication.`);
        requires2FA = true;
        dispatch(sessionRequires2FA({
          otpToken: response.getIn(['data', 'token']),
          challenge: response.getIn(['data', 'challenge']),
          secret: response.getIn(['data', 'secret']),
          provisioning_uri: response.getIn(['data', 'provisioning_uri']),
        }));
      
      // incorrect credentials
      } else {
        Logger.log('info', `GET API token failure.`);
        dispatch(sessionCreateFailure(response.getIn(['data', 'error'])));
      }
    }

    // callback function
    cb(success, requires2FA);
  }
}

export function destroySession(cb=function(){}) {
  Logger.log('debug', `[actions] destroySession(###)`);
  return async function(dispatch) {
    dispatch(sessionDestroy());
    cb();
  }
}

Logger.log('silly', `actions loaded.`);
